import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M35.078 0h-35v35h35V0Zm-9.066 10.771Zm0 0c-.645.316-1.28.49-1.929.668-.206.056-.414.113-.624.175-.954-1.077-2.37-1.137-3.729-.627-1.36.509-2.25 1.753-2.23 3.18v.852c-2.762.07-5.222-1.188-6.81-3.405 0 0-3.56 6.327 3.405 9.364-1.594 1.061-3.183 1.777-5.107 1.702 2.816 1.535 5.884 2.063 8.54 1.291 3.048-.885 5.553-3.169 6.514-6.59.286-1.04.429-2.115.423-3.195 0-.081.19-.45.44-.933.397-.77.946-1.832 1.107-2.482Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgTwitter;